import * as React from 'react';
import QRCode from 'qrcode';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { DataService } from '../../services/data_service';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WActionButton } from '../../core/elements/WActionButton';
import { getStaticOption } from '../../core/forms/helpers/getStaticOption';
import { fn2d, fn0 } from '../../core/formatter/formatNumber';
import * as config from '../../wips.config.js';

export interface DateneingabePendelnKampagneProps {
    rowTid: number;
    data: any;
    onClose: () => void;
}

export interface DateneingabePendelnKampagneState {
    dataItem?: any;
    logo?: string;
    qrUrl?: string;
    showSpinner?: boolean;
}

export class DateneingabePendelnKampagne extends React.Component<DateneingabePendelnKampagneProps, DateneingabePendelnKampagneState> {

    constructor(props: any) {
        super(props);
        this.state = {

        };
        this.openBefragungTool = this.openBefragungTool.bind(this);
        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.renderQRcode = this.renderQRcode.bind(this);
        this.importData = this.importData.bind(this);
        this.updateDataItem = this.updateDataItem.bind(this);

        this.befragungUrl = config.befragungPendelnUrl;
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;
    @lazyInject(DataService) private dataService: DataService;

    private standortOrt: string;
    private befragungUrl: string;

    componentDidMount(): void {
        this.loadLogo();
        this.updateDataItem();
    }

    componentDidUpdate(prevProps: Readonly<DateneingabePendelnKampagneProps>, prevState: Readonly<DateneingabePendelnKampagneState>): void {
        this.updateDataItem(prevState);
    }

    loadLogo() {
        const uData = this.props.data[IDs.ENT_UNTERNEHMENSDATEN][0] || {};
        if (uData.datei_logo > 0) {
            this.dataService.loadDataForModul(IDs.ENT_ARCHIV_ITEMS, { tid: uData.datei_logo }, { resolve: true, fieldList: 'name, file' }, 'wips', (result: any) => {
                if ((result[IDs.ENT_ARCHIV_ITEMS] || []).length) {
                    let logo: string = result[IDs.ENT_ARCHIV_ITEMS][0].file;
                    if (logo) {
                        this.setState({ logo });
                    }
                }
            });
        }
    }

    updateDataItem(prevState?: any) {
        if (this.props.rowTid > 0 && this.props.data && Array.isArray(this.props.data[IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE])) {
            const standorte = this.props.data[IDs.ENT_STANDORT];
            const rowFnd = this.props.data[IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE].find((r: any) => r.tid === this.props.rowTid);
            const rowStandortTid = rowFnd && rowFnd.standort_tid_orig > 0 ? rowFnd.standort_tid_orig : rowFnd.standort_tid > 0 ? rowFnd.standort_tid : null;
            if (rowStandortTid > 0) {
                const standort = standorte.find((s: any) => s.tid === rowStandortTid);
                if (standort) {
                    if (standort.standort_typ_tid_orig === 5 /* Veranstaltung */) {
                        const standort2 = standorte.find((s: any) => s.tid === standort.standort_tid_orig);
                        this.standortOrt = standort2 ? standort2.ort : '';
                    } else {
                        this.standortOrt = standort.ort;
                    }
                }
            }
            if (rowFnd) {
                if (JSON.stringify(rowFnd) !== JSON.stringify(this.state.dataItem)) {
                    this.setState({ dataItem: rowFnd });
                    this.renderQRcode(rowFnd);
                } else if ((!prevState && this.state.logo) || (prevState && this.state.logo !== prevState.logo)) {
                    this.renderQRcode(rowFnd);
                }
            }
        }
    }

    render(): JSX.Element {
        if (!this.state.dataItem) {
            return null;
        }
        const row = this.state.dataItem;
        return <div style={{ display: 'flex', flex: 1, flexDirection: 'row' }}>
            <div style={{ marginLeft: 20 }}>
                <div style={{ paddingRight: 10 }}>Kampagne: <b>{row.name}</b></div>
                <WActionButton
                    label='Befragung-Tool öffnen'
                    insideText='Befragung-Tool öffnen'
                    insideLeftMargin={0}
                    key='btn_open'
                    styleProps={{ margin: 0, width: 300, marginTop: 10 }}
                    action='open'
                    onAction={() => this.openBefragungTool()}
                />
                <WActionButton
                    label='Daten importieren'
                    insideText='Daten importieren'
                    insideLeftMargin={0}
                    key='btn_edit'
                    styleProps={{ margin: 0, width: 300, marginTop: 10 }}
                    action='open'
                    onAction={() => this.setState({ showSpinner: true }, () => this.importData(row.kennung))}
                />
                <WActionButton
                    label='Link in die Zwischenablage kopieren'
                    insideText='Link in die Zwischenablage kopieren'
                    insideLeftMargin={0}
                    styleProps={{ margin: 0, width: 300, marginTop: 10 }}
                    key='btn_copy'
                    action='open'
                    onAction={() => this.copyToClipboard()}
                />
                {this.state.qrUrl && <img alt='QR' src={this.state.qrUrl} />}
                <WActionButton
                    label='Daten als CSV herunterladen'
                    insideText='Daten als CSV herunterladen'
                    insideLeftMargin={0}
                    styleProps={{ margin: 0, width: 300 }}
                    key='btn_csv'
                    action='open'
                    onAction={() => this.exportCSV(row)}
                />
            </div>
            <div>
                {this.renderResults()}
            </div>
        </div>;
    }

    renderResults() {
        const jsonStr = this.state.dataItem.ergebnis;
        let results: any;
        try {
            results = JSON.parse(jsonStr);
        } catch (e) {
            console.error(e, jsonStr);
        }
        if (!results) {
            return <div>Es wurden noch keine Daten erfasst und/oder verarbeitet!</div>;
        }
        const transportation = Object.keys(results.transportation || {}).map((k: string) => {
            return {
                key: k,
                ...results.transportation[k]
            };
        }).sort((a: any, b: any) => b.km - a.km);
        const uebernachtung = Object.keys(results.uebernachtung || {}).map((k: string) => {
            return {
                key: k,
                ...results.uebernachtung[k]
            };
        }).sort((a: any, b: any) => b.uebern - a.uebern);
        const mitarbeiter_erwartet = this.state.dataItem.mitarbeiter;
        const mitarbeiter_erfasst = this.state.dataItem.mitarbeiter_erfasst;
        const faktor_hochrechnung = (mitarbeiter_erwartet / mitarbeiter_erfasst) || 1;
        const style_field: React.CSSProperties = { width: 100, fontSize: '11px', backgroundColor: '#F0F0F0', borderBottom: '1px solid #AAA', padding: 3 };
        const style_field_b: React.CSSProperties = { ...style_field, fontWeight: 'bold', textAlign: 'right' };
        const style_field_r: React.CSSProperties = { ...style_field, textAlign: 'right' };
        const style_field_b220: React.CSSProperties = { ...style_field_b, textAlign: 'left', width: 220 };

        return <div style={{ margin: 10 }}>
            {transportation.length > 0 && <React.Fragment>
                <div style={{ backgroundColor: '#888', fontWeight: 'bold', color: '#FFF', marginBottom: 10, padding: 3 }}>
                    Entfernungen
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                    <div style={style_field_b220}>Transportmittel</div>
                    <div style={style_field_b}>Entfernung (km) erfasst</div>
                    <div style={style_field_b}>Personen erfasst</div>
                    <div style={style_field_b}>Entfernung (km) hochgerechnet</div>
                </div>
                {transportation.map((t: any) => {
                    let tkey = t.key;
                    let kKey;
                    // WKETOOL-125: Kraftstoff Autos
                    if (tkey.indexOf('&kraftstoff=') !== -1) {
                        const keyArr = tkey.split('&kraftstoff=');
                        tkey = keyArr[0];
                        kKey = keyArr[1];
                    }
                    return <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                        <div style={style_field_b220}>
                            {getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'transportmittel', tkey)}
                            {kKey ? ` (${getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'kraftstoff', kKey)})` : ''}
                        </div>
                        <div style={style_field_r}>{fn0(t.km)}</div>
                        <div style={style_field_r}>{fn0(t.cnt)}</div>
                        <div style={style_field_r}>{fn2d(Math.round(t.km * faktor_hochrechnung))}</div>
                    </div>;
                })}
            </React.Fragment>}
            {uebernachtung.length > 0 && <React.Fragment>
                <div style={{ backgroundColor: '#888', fontWeight: 'bold', color: '#FFF', marginBottom: 10, marginTop: 10, padding: 3 }}>
                    Übernachtungen
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                    <div style={style_field_b220}>Unterkunft</div>
                    <div style={style_field_b}>Übernachtungen erfasst</div>
                    <div style={style_field_b}>Personen erfasst</div>
                    <div style={style_field_b}>Übernachtungen hochgerechnet</div>
                </div>
                {uebernachtung.map((u: any) =>
                    <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                        <div style={style_field_b220}>{getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'unterkunft', u.key)}</div>
                        <div style={style_field_r}>{fn0(u.uebern)}</div>
                        <div style={style_field_r}>{fn0(u.cnt)}</div>
                        <div style={style_field_r}>{fn2d(Math.round(u.uebern * faktor_hochrechnung))}</div>
                    </div>)}
            </React.Fragment>}
        </div>;
    }

    renderQRcode(kampagne?: any) {
        const link = this.getToolUrl(kampagne);
        if (link) {
            QRCode.toDataURL(link, { width: 300, errorCorrectionLevel: 'H' })
                .then(qrUrl => {
                    this.setState({ qrUrl: qrUrl });
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }

    copyToClipboard() {
        const link = this.getToolUrl();
        if (link) {
            const textarea = document.createElement('textarea');
            document.body.appendChild(textarea);
            textarea.value = link;
            textarea.select();
            textarea.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(textarea.value);
            document.body.removeChild(textarea);
            alert('Link wurde kopiert!');
        }
    }

    openBefragungTool() {
        const link = this.getToolUrl();
        if (link) {
            window.open(link, '_blank').focus();
        }
    }

    getToolUrl(kampagne?: any) {
        kampagne = kampagne || this.state.dataItem;
        if (!kampagne || !kampagne.kennung) {
            alert('Fehler: Unbekannte Kennung.\nBitte speichern Sie den Datensatz erneut!');
            this.props.onClose();
            return false;
        }
        const data = {
            name: kampagne.name,
            jahr: kampagne.jahr,
            logo: this.state.logo,
            ort: this.standortOrt
        }
        const url = this.befragungUrl + 'index.php?fId='
            + btoa(`data/kampagne_${kampagne.kennung}.json`)
            + '&data='
            + btoa(encodeURI(JSON.stringify(data)));
        // console.log(kampagne.kennung);
        // console.log(data, url);
        return url;
    }

    importData(kennung: string) {
        const link = this.befragungUrl + `data/kampagne_${kennung}.json?stamp=${new Date().getTime()}`;
        fetch(link, {})
            .then(response => {
                return response.text();
            })
            .then(text => {
                const results = this.processJsonString(text);
                const saveItem = {
                    tid: this.state.dataItem.tid,
                    daten: text,
                    mitarbeiter_erfasst: results.count,
                    ergebnis: JSON.stringify(results)
                };
                this.dataService.saveData(IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE, saveItem, undefined, false, (suc: boolean, saveTid: number) => {
                    this.triggerService.fire('reload', IDs.ENT_CO2_SCOPE3_PENDELN_KAMPAGNE);
                    this.setState({ showSpinner: false });
                    alert('Es wurden ' + results.count + ' Datensätze importiert!');
                }, IDs.MOD_ETOOL);
            })
            .catch((e) => {
                alert('Es wurden keine Datensätze gefunden.');
                console.error(e, link);
            });
    }

    getTransportmittelKey(key: string, value: number, kraftstoff: string) {
        if (key === 'pkw_klein' || key === 'pkw_mittel' || key === 'pkw_gross') {
            // WKETOOL-125: Kraftstoff Autos
            if (kraftstoff) {
                return `${key}&kraftstoff=${kraftstoff}`;
            }
        }
        return key;
    }

    processJsonString(jsonStr: string) {
        let arr;
        try {
            arr = JSON.parse(jsonStr);
        } catch (e) {
            console.error(e, jsonStr);
        }
        const res: any = {
            count: 0,
            transportation: {},
            uebernachtung: {}
        };
        if (Array.isArray(arr)) {
            res.count = arr.length;
            arr.forEach((form: any) => {
                if (form && Array.isArray(form.data)) {
                    const transCnt: any = {};
                    form.data.forEach((row: any) => {
                        const dataKeys = Object.keys(row);
                        // Wochenpendler?
                        let commute_weeks = 0;
                        if (row.p1_weekly_commuter) {
                            commute_weeks = row.p2_commute_weeks || 0;
                        }
                        // Transportation                        
                        dataKeys.filter((k: string) => k.indexOf('_transportation_') !== -1 && k.indexOf('_transportation_uebernachtung') === -1 && row[k] > 0)
                            .forEach((k: string) => {
                                const value = row[k];
                                const kraftstoff = row[k + '_kraftstoff'];
                                const keyArr = k.split('_transportation_');
                                const pKey = keyArr[0];
                                let tKey = keyArr[1];
                                tKey = this.getTransportmittelKey(tKey, value, kraftstoff);
                                if (!res.transportation[tKey]) {
                                    res.transportation[tKey] = {
                                        km: 0,
                                        cnt: 0
                                    };
                                }
                                if (pKey === 'p2') {
                                    if (commute_weeks > 0) {
                                        const factor = 2;
                                        res.transportation[tKey].km += value * factor * commute_weeks;
                                        transCnt[tKey] = 1;
                                    }
                                    // console.log('Wochenpendler', tKey, value, weekly_days);
                                } else {
                                    const factor = row.p9_same_return === false ? 1 : 2;
                                    let days = row.p8_days_applied || row.p1_commute_days;
                                    if (days > 0) {
                                        res.transportation[tKey].km += value * factor * days;
                                        transCnt[tKey] = 1;
                                    }
                                    // console.log('Kein Wochenpendler', tKey, value, days, factor);
                                }
                            });
                        // Übernachtung
                        if (commute_weeks > 0 && row.p2_transportation_uebernachtung > 0 && row.p2_uebernachtung_art) {
                            const uKey = row.p2_uebernachtung_art;
                            if (!res.uebernachtung[uKey]) {
                                res.uebernachtung[uKey] = {
                                    uebern: 0,
                                    cnt: 0
                                };
                            }
                            res.uebernachtung[uKey].uebern += row.p2_transportation_uebernachtung * commute_weeks;
                            res.uebernachtung[uKey].cnt++;
                        }
                    });
                    Object.keys(transCnt).forEach((tKey: string) => {
                        res.transportation[tKey].cnt++;
                    });
                }
            });
        }
        console.log(arr);
        console.log(res);
        return res;
    }

    exportCSV(kampagne: any) {
        const jsonStr = kampagne.daten;
        let arr;
        try {
            arr = JSON.parse(jsonStr);
        } catch (e) {
            console.error(e, jsonStr);
        }
        if (!arr) {
            alert('Es wurden noch keine Daten erfasst und/oder importiert!');
            return;
        }

        const exportArr: any[] = [
            ['ID', 'Laufende Nummer', 'Sprache', 'Fuß/Fahrrad', 'Pedelec', 'Tram', 'Bus', 'Nahverkehr', 'Fernverkehr', 'Auto: klein', 'Auto: mittel', 'Auto: groß', 'Motorrad', 'Wöchentliche Reise', 'Wochen', 'Tage', 'Faktor', 'Übernachtung pro Woche', 'Unterkunftsart']
        ];
        const transKeys: Array<any> = ['fuss', 'e_bike', 'tram', 'bus', 'bahn', 'bahn_fern', 'pkw_klein', 'pkw_mittel', 'pkw_gross', 'krad'];
        if (Array.isArray(arr)) {
            arr.forEach((form: any, i: number) => {
                let isWeeklycommuter = false;
                if (form && form.meta && Array.isArray(form.data)) {
                    form.data.forEach((row: any, j: number) => {
                        // Wochenpendler?
                        let weekly_days = 0;
                        if (row.p1_weekly_commuter) {
                            weekly_days = (row.p1_working_days || 0) * (row.p2_commute_weeks || 0);
                        }
                        if (weekly_days > 0) {
                            exportArr.push([
                                ...[
                                    `MA ${i + 1}`,
                                    j + 1,
                                    form.meta.lang
                                ],
                                ...(transKeys.map((k: string) => row[`p2_transportation_${k}`] || '')),
                                ...[
                                    'Ja',
                                    row.p2_commute_weeks,
                                    weekly_days,
                                    2,
                                    row.p2_transportation_uebernachtung > 0 ? row.p2_transportation_uebernachtung : '',
                                    row.p2_transportation_uebernachtung > 0 && row.p2_uebernachtung_art ? getStaticOption(IDs.ENT_CO2_SCOPE3_PENDELN, 'unterkunft', row.p2_uebernachtung_art) : ''
                                ]
                            ]);
                            isWeeklycommuter = true;
                        }
                        exportArr.push([
                            ...[
                                `MA ${i + 1}`,
                                j + (isWeeklycommuter ? 2 : 1),
                                form.meta.lang
                            ],
                            ...(transKeys.map((k: string) => this.getRowValByTranspKey(row, k) || '')),
                            ...[
                                'Nein',
                                '',
                                row.p8_days_applied || row.p1_commute_days,
                                row.p9_same_return === false ? 1 : 2
                            ]
                        ]);
                    });
                }
            });
        }
        // console.log(arr);
        // console.log(exportArr);
        let csv = '\ufeff' /* BOM */ + exportArr.map((r: Array<string>) => r.map((c: string) => `"${c}"`).join(';')).join('\r\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const filename = `Export Mitarbeiter-Umfrage ${kampagne.kennung}.csv`;
        saveAs(url, filename);
    }

    getRowValByTranspKey(row: any, key: string) {
        const value = Object.keys(row).reduce((accumulator: number, currKey: string) =>
            accumulator + (!currKey.startsWith(`p2_transportation_`) && currKey.endsWith(`_transportation_${key}`) ? row[currKey] : 0), 0);
        // console.log(key, value);
        return value;
    }
}
